// Define local components
import carouselConfig from './components/carousel';
import navigation from './components/navigation';

carouselConfig();
navigation();
